export enum Tone {
    default = 'default',
    prefer_confident = 'prefer_confident',
    prefer_diplomatic = 'prefer_diplomatic',
    prefer_enthusiastic = 'prefer_enthusiastic',
    prefer_friendly = 'prefer_friendly',
}
